import IconButton from "../../components/IconButton";
import RequestContainer from "../../components/RequestContainer";
import ViewContents from "../../components/ViewContents";
import ViewHeader from "../../components/ViewHeader";
import WorkForm from "../../forms/WorkForm";
import toast from "../../lib/toast";
import { Save } from "react-feather";
import { createWork } from "../../clients/art";
import { useHistory } from "react-router-dom";
import { useQueryString } from "../../hooks/useQueryString";
import { useRequest } from "../../hooks/useRequest";

function NewWork() {
  const artistId = useQueryString("artistId");
  const eventId = useQueryString("eventId");
  const offerId = useQueryString("offerId");
  const createRequest = useRequest(createWork);
  let history = useHistory();

  return (
    <WorkForm
      onSubmit={(values, actions) => {
        const createOneMore =
          window.event.submitter.classList.contains("create-one-more");

        createRequest.execute(
          { ...values, artistId, eventId, offerId },
          (response) => {
            if (createOneMore) {
              actions.resetForm();
            } else {
              history.push(`/works/${response.data.id}`);
            }
            toast("The work was created");
          }
        );
      }}
    >
      {(fields) => (
        <>
          <ViewHeader
            breadcrumbs={["New work"]}
            actions={
              <>
                <IconButton
                  type="submit"
                  disabled={createRequest.loading}
                  icon={Save}
                  className="btn btn-secondary me-2 create-one-more"
                >
                  Save and create one more
                </IconButton>
                <IconButton
                  type="submit"
                  disabled={createRequest.loading}
                  icon={Save}
                  className="btn btn-success"
                >
                  Save
                </IconButton>
              </>
            }
          />
          <ViewContents>
            <RequestContainer
              loading={createRequest.loading}
              error={createRequest.error}
            >
              {fields}
            </RequestContainer>
          </ViewContents>
        </>
      )}
    </WorkForm>
  );
}

export default NewWork;
